// Swap contract (.js-listing-results > .js-listing-count + .js-listing-items) is rendered by Pagination/_listingResults.cshtml
/** @param {HTMLFormElement} form */
export default function FilteredListing(form) {
  if (window.isTurnStorybook) return;

  const results = form.querySelector('.js-listing-results');
  if (!results) return;

  let controller;

  const pageKey = () => window.location.pathname + window.location.search;
  let currentKey = pageKey();

  const isPlainClick = (event) =>
    event.button === 0 && !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);

  const buildUrl = () => {
    const url = new URL(form.getAttribute('action') || '', window.location.href);
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    url.search = params.toString();
    return url.toString();
  };

  const syncControls = () => {
    const params = new URLSearchParams(window.location.search);
    form.querySelectorAll('select, input[type="text"], input[type="search"]').forEach((control) => {
      if (control.name) control.value = params.get(control.name) || '';
    });
  };

  const clearControls = () => {
    form.querySelectorAll('select, input[type="text"], input[type="search"]').forEach((control) => {
      if (control.name) control.value = '';
    });
  };

  const load = async (url, { push = false, focusResults = false } = {}) => {
    if (controller) controller.abort();
    controller = new AbortController();
    results.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fragment = doc.querySelector('.js-listing-results');
      if (!fragment) throw new Error('No results fragment in response');

      const items = results.querySelector('.js-listing-items');
      const freshItems = fragment.querySelector('.js-listing-items');
      if (!items || !freshItems) throw new Error('No listing items in response');

      items.innerHTML = freshItems.innerHTML;
      results.removeAttribute('aria-busy');

      // count node persists (textContent only) so its role="status" keeps announcing; set after aria-busy clears
      const count = results.querySelector('.js-listing-count');
      const freshCount = fragment.querySelector('.js-listing-count');
      if (count && freshCount) count.textContent = freshCount.textContent;

      const target = new URL(url, window.location.href);
      if (push && target.pathname + target.search !== pageKey()) window.history.pushState(null, '', target.href);
      currentKey = pageKey();

      if (focusResults) {
        if (!results.hasAttribute('tabindex')) results.setAttribute('tabindex', '-1');
        results.focus();
        results.scrollIntoView({ block: 'start' });
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(url);
    }
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    load(buildUrl(), { push: true });
  });

  form.querySelectorAll('a.js-listing-reset[href]').forEach((reset) => {
    reset.addEventListener('click', (event) => {
      if (!isPlainClick(event)) return;
      event.preventDefault();
      clearControls();
      load(reset.href, { push: true });
    });
  });

  results.addEventListener('click', (event) => {
    const link = event.target.closest('a.pagination__item[href]');
    if (!link || !isPlainClick(event)) return;
    event.preventDefault();
    load(link.href, { push: true, focusResults: true });
  });

  window.addEventListener('popstate', () => {
    if (pageKey() === currentKey) return;
    currentKey = pageKey();
    syncControls();
    load(window.location.href);
  });
}
